export default __webpack_public_path__ + "transfix-maps/icons/D.4c4d150398aa4a717f02e16044cc7b37.png";